import React, { useContext, useEffect, useState } from 'react'
import CustomAddPage from '../../components/CustomComponents/CustomAddPage'
import { CompanyConfigContext } from '../../context api/Configuration/CompanyConfig'
import { useModuleAdmins } from '../../hooks/Authentication/useModuleAdmins'
import { usePermissions } from '../../hooks/Authentication/usePermissions'
import { sortByName } from '../../shared/constants'

export default function AddModuleAdmin({ moduleAdmin }) {
  const [moduleAdminData, setModuleAdminData] = useState({
    moduleAdminCode: '',
    email: '',
    dob: new Date().toISOString(),
    password: '',
    firstName: '',
    lastName: '',
    phoneNumber: '',
    permissions: '',
    active: true,
  })

  const { addModuleAdmin, loading, updateModuleAdmin } = useModuleAdmins()
  const { getAllPermissions } = usePermissions()
  const { permissions } = useContext(CompanyConfigContext)

  const handleModuleAdmin = () => {
    if (moduleAdmin) {
      updateModuleAdmin({ ...moduleAdminData, moduleAdminId: moduleAdmin._id })
    } else {
      addModuleAdmin(moduleAdminData)
    }
  }
  useEffect(() => {
    getAllPermissions()
  }, [])

  useEffect(() => {
    if (moduleAdmin) {
      setModuleAdminData({
        ...moduleAdmin,
        permissions: moduleAdmin.permissions && moduleAdmin.permissions._id,
      })
    }
  }, [moduleAdmin])

  const data = [
    { label: 'Module Admin Code', value: moduleAdminData.moduleAdminCode, name: 'moduleAdminCode' },
    { label: 'First Name', value: moduleAdminData.firstName, name: 'firstName' },
    { label: 'Last Name', value: moduleAdminData.lastName, name: 'lastName' },
    { label: 'DOB', value: moduleAdminData.dob, name: 'dob', type: 'DATE' },
    { label: 'Email', value: moduleAdminData.email, name: 'email', conditions: [{ type: 'EMAIL' }] },
    { label: 'Password', value: moduleAdminData.password, name: 'password', type: 'password', noDisplay: moduleAdmin ? true : false, conditions: [{ type: 'PASSWORD' }],  },
    { label: 'Phone Number', value: moduleAdminData.phoneNumber, name: 'phoneNumber', conditions: [{ type: 'PHONE' }], type: 'NUMBER',  },
    { label: 'Permission', value: moduleAdminData.permissions, name: 'permissions', options: sortByName(permissions, 'name'), fieldName: 'name', fieldValue: '_id' },
    { label: 'Status', value: moduleAdminData.active, type: 'ACTIVE' },
  ]

  return (
    <CustomAddPage
      heading="Module Admin"
      redirect="ALL_MODULEADMINS"
      currentData={moduleAdmin}
      loading={loading}
      state={moduleAdminData}
      setState={setModuleAdminData}
      handleClick={handleModuleAdmin}
      inputFields={data}
    />
  )
}
